module.exports = __webpack_public_path__ + "img/eMatica_logo.df953360.svg";